import { format } from "date-fns";
import { AlertTriangle } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

// A day is "recent" when it's today or up to 2 days back. Future dates are never recent.
export const isNotRecentDay = (d) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const day = new Date(d);
  day.setHours(0, 0, 0, 0);
  const diffDays = Math.round((today - day) / 86400000);
  return diffDays < 0 || diffDays > 2;
};

// Confirmation shown when the user switches to a non-recent date — prevents
// accidentally entering today's numbers on an old (or future) page.
export const DateWarningDialog = ({ pendingDate, onConfirm, onToday, onCancel, testIdPrefix = "date-warning" }) => {
  if (!pendingDate) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const day = new Date(pendingDate);
  day.setHours(0, 0, 0, 0);
  const diffDays = Math.round((today - day) / 86400000);
  const isFuture = diffDays < 0;
  const n = Math.abs(diffDays);
  return (
    <Dialog open onOpenChange={(o) => { if (!o) onCancel(); }}>
      <DialogContent data-testid={`${testIdPrefix}-dialog`}>
        <DialogHeader>
          <DialogTitle className="font-mono flex items-center gap-2 text-amber-400">
            <AlertTriangle className="w-5 h-5" /> Not a recent day
          </DialogTitle>
          <DialogDescription className="font-mono pt-2">
            You&apos;re switching to{" "}
            <strong className="text-foreground">{format(pendingDate, "EEE, MMM d, yyyy")}</strong> —{" "}
            <strong className={isFuture ? "text-rose-400" : "text-amber-400"}>
              {isFuture ? `${n} day${n === 1 ? "" : "s"} in the future` : `${n} days ago`}
            </strong>
            . Make sure this is really the day you want to work on.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={onToday} className="font-mono" data-testid={`${testIdPrefix}-today-btn`}>
            Go to Today
          </Button>
          <Button onClick={onConfirm} className="bg-amber-500 text-black hover:bg-amber-400 font-mono font-bold" data-testid={`${testIdPrefix}-confirm-btn`}>
            Yes, use this date
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
